module.exports = __webpack_public_path__ + "img/eminem.5d63923c.jpg";